/* eslint-disable react/prop-types */
import HeaderContainer from "../headerSection/HeaderSection";
import NextSection from "../nextHeaderSection/NextSection";
import PrimaryBeneficary from "../primaryBeneficary/PrimaryBeneficary";
import ContignantBeneficiary from "../contignantBeneficary/ContignantBeneficiary";
import TermsCondition from "../footerTerms/TermsCondition";
import { forwardRef } from "react";
import { GLIFormPrintProps } from "../../../../../../../../../@types/components/gliFormProps.types";

// eslint-disable-next-line react/display-name
const GLIFormPrint = forwardRef(({ enrollments, enrollmentDate }: GLIFormPrintProps, ref: any) => {
	const { employee, contingent_beneficiery, primary_beneficiery } = enrollments;
	if (!employee && !contingent_beneficiery && !primary_beneficiery) return <></>;
	return (
		<div className="gli-form-container" ref={ref}>
			<div className="gli-print-margin">
				<HeaderContainer isPrintable={true} />
				<NextSection isPrintable={true} employee={employee} />
				<PrimaryBeneficary isPrintable={true} primaryBeneficery={primary_beneficiery} />
				<ContignantBeneficiary isPrintable={true} contingentBeneficiery={contingent_beneficiery} />
				<TermsCondition isPrintable={true} employee={employee} enrollmentDate={enrollmentDate} />
			</div>
		</div>
	);
});

export default GLIFormPrint;
